import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./app.vue";
import router from "./router/index.ts";
import "./site.css";

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  var __REDISKU_RUNTIME_CONFIG__: RediskuRuntimeConfig | undefined;
}

// A committed env file carries an empty value for environments with no Application Insights
// resource, so blank is normalized to undefined and falls through to the runtime config the
// Docker container writes into runtime-config.js at startup.
const trimmedBuildTimeConnectionString =
  import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING?.trim();
const buildTimeConnectionString =
  trimmedBuildTimeConnectionString === ""
    ? undefined
    : trimmedBuildTimeConnectionString;

const appInsightsConnectionString =
  buildTimeConnectionString ??
  globalThis.__REDISKU_RUNTIME_CONFIG__?.applicationInsightsConnectionString;

if (appInsightsConnectionString) {
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: appInsightsConnectionString,
      enableAutoRouteTracking: true,
    },
  });
  appInsights.loadAppInsights();
}

ModuleRegistry.registerModules([AllCommunityModule]);

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.mount("#app");

// Poll job status for async redistribution job notifications. Front Door forcibly disconnects
// any long-lived HTTP connection (e.g. SSE) every ~30 seconds regardless of activity, so polling
// is the only reliable way to learn a job's outcome.
import { startRedistributionPolling } from "./services/redistributionPolling.ts";
startRedistributionPolling();
